import { dashboardApi } from '../dashboard-api';
import { AiQaConfigurationTestResponse } from '../insights/types';
import { AI_QA_ROUTER_BASE } from './constants';
import {
  AiQaConfig,
  AiQaConfigGetResponse,
  AiQaConfigurationCreateRequest,
  AiQaConfigurationsGetRequest,
  AiQaConfigurationTestPayloadRequest,
  OrgFeatureQaConfigResponse,
  RubricFilterOptionResponse,
} from './types';

const aiQaApi = dashboardApi.injectEndpoints({
  endpoints: builder => ({
    createAiQaProductConfig: builder.mutation<
      AiQaConfig,
      AiQaConfigurationCreateRequest
    >({
      invalidatesTags: ['AiQaConfigs'],
      query: params => ({
        body: params,
        method: 'POST',
        url: AI_QA_ROUTER_BASE + '/configuration',
      }),
    }),
    deleteAiQaProductConfig: builder.mutation<void, { model_id: string }>({
      invalidatesTags: ['AiQaConfigs'],
      query: params => ({
        body: params,
        method: 'DELETE',
        url: `${AI_QA_ROUTER_BASE}/configurations/${params.model_id}`,
      }),
    }),
    getAiQaProductConfigs: builder.query<
      AiQaConfigGetResponse,
      AiQaConfigurationsGetRequest
    >({
      providesTags: ['AiQaConfigs'],
      query: params => ({
        params,
        url: AI_QA_ROUTER_BASE + '/configurations',
      }),
    }),
    getOrgFeatureAiQaConfig: builder.query<OrgFeatureQaConfigResponse, void>({
      query: () => ({
        url: AI_QA_ROUTER_BASE + '/org-feature-ai-qa-configurations',
      }),
    }),
    getRubricFilterOptions: builder.query<RubricFilterOptionResponse, void>({
      query: () => ({
        url: AI_QA_ROUTER_BASE + '/rubric-filter-options',
      }),
    }),
    testAiQaSolveConfig: builder.mutation<
      AiQaConfigurationTestResponse,
      AiQaConfigurationTestPayloadRequest
    >({
      query: params => ({
        body: params,
        method: 'POST',
        url: AI_QA_ROUTER_BASE + '/test',
      }),
    }),
    updateAiQaProductConfig: builder.mutation<
      void,
      AiQaConfigurationCreateRequest
    >({
      invalidatesTags: ['AiQaConfigs'],
      query: params => ({
        body: params,
        method: 'PUT',
        url: `${AI_QA_ROUTER_BASE}/configurations/${params.model_id}`,
      }),
    }),
  }),
});

export const {
  useCreateAiQaProductConfigMutation,
  useDeleteAiQaProductConfigMutation,
  useGetAiQaProductConfigsQuery,
  useGetOrgFeatureAiQaConfigQuery,
  useGetRubricFilterOptionsQuery,
  useTestAiQaSolveConfigMutation,
  useUpdateAiQaProductConfigMutation,
} = aiQaApi;
